import requests from '@/api/request'
import Cookie from "js-cookie";
let BASE_URL = `api`
let api = {
    add: `${BASE_URL}/plan/rulesregulation/add`,//新增
    update: `${BASE_URL}/plan/rulesregulation/update`,//修改
    getList:`${BASE_URL}/plan/rulesregulation/pagelist` ,//查询
    deatile:`${BASE_URL}/plan/rulesregulation/get` ,//详情
    GETLABEILIST: `${BASE_URL}/label/getLabelList`,//获取所有标签名称和ID
}
// 查询
export async function rulesregulationPagelist(data) {
    return requests({
        url: api.getList,
        method: 'post',
        data,
        headers: {
            token: Cookie.get("tokenAdmin"),
        }
    }
    )
}
// 新增
export async function rulesregulationAdd(data) {
    return requests({
        url: api.add,
        method: 'post',
        data,
        headers: {
            token: Cookie.get("tokenAdmin"),
        }
    }
    )
}
// 修改
export async function rulesregulationUpdate(data) {
    return requests({
        url: api.update,
        method: 'post',
        data,
        headers: {
            token: Cookie.get("tokenAdmin"),
        }
    }
    )
}
// 详情
export async function rulesregulationGet(params) {
    return requests({
        url: api.deatile,
        method: 'get',
        params,
        headers: {
            token: Cookie.get("tokenAdmin"),
        }
    }
    )
}

// 获取标签列表
export async function getLabelListApi(data) {
    return requests({
        url: api.GETLABEILIST,
        method: 'get',
        params: data,
        headers: {
            // token: Cookie.get("tokenAdmin"),
            // token: 'JJP94liJ2n5rOrLNmpc/S0Pt8BrPlbcGOY0CD0w8ZFU=',
            'content-type': 'application/json'
        }
    })
}

